import { useEffect } from 'react'
import { useAppDispatch } from 'app/hooks'
import { getLiveReportId, getLiveReportInfo } from 'features/liveReportConfig/asyncThunks'
import { getSuggestedUserList } from 'features/suggestedUsers/asyncThunks'
import { useAccountId } from 'hooks/usePageConfig'

const useRetrieveLiveReportConfig = (dashboardId: number) => {
  const dispatch = useAppDispatch()
  const accountId = useAccountId()

  useEffect(() => {
    dispatch(getLiveReportId({ dashboardId }))
    dispatch(getLiveReportInfo({ dashboardId }))
    dispatch(getSuggestedUserList(accountId!))
  }, [dispatch, dashboardId, accountId])
}

export default useRetrieveLiveReportConfig
